<div class="flex items-start w-full" [formGroup]="phoneForm">
    <mat-form-field class="w-1/3 pr-2">
        <mat-label>Code</mat-label>
        <mat-select formControlName="code">
            <mat-option *ngFor="let country of countryCodes" [value]="country.code">
                {{ country.iso }} ({{ country.code }})
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="w-2/3">
        <mat-label>Phone Number</mat-label>
        <input
            matInput
            type="tel"
            formControlName="number"
            placeholder="555-123-4567"
            (blur)="_onTouched()">
    </mat-form-field>
</div>
